import { Link, NavLink } from "react-router-dom";
import Button from "../components/button/Button.tsx";
import MobileHeader from "./Mobile-header.tsx";
import { content } from "../data.tsx";
import UseAuth from "../utils/use-auth.ts";
import UseChat from "../utils/use-chat.ts";

const Header = ({ className }: { className?: string }) => {
  const { setCurrentConversation } = UseChat();
  const { user, HandleUserLogOut } = UseAuth();

  return (
    <div
      className={`sticky bg-white/80 backdrop-blur-md top-0 z-50 w-full max-w-[1440px] mx-auto border-b border-gray-100 ${className}`}
    >
      <div className="flex justify-center lg:w-[95%] w-[95%] py-3 mx-auto h-[72px]">
        <div className="w-[100%] flex items-center justify-between">
          <div className="flex items-center justify-start">
            <div className="flex justify-start mr-10">
              <Link to="/">
                <img
                  className="w-[78px]"
                  src="/assets/images/coachai.png"
                  alt="Logo"
                />
              </Link>
            </div>
            <div className="justify-center hidden gap-1 lg:flex">
              {content.menuItems.map((item, index) => (
                <NavLink
                  to={item.url}
                  key={index}
                  className={({ isActive }) =>
                    `px-4 py-2 rounded-lg text-[14.5px] font-medium tracking-tight transition-colors duration-200 ${
                      isActive
                        ? "text-blue bg-blue/5"
                        : "text-lightBlack hover:text-blue hover:bg-gray-50"
                    }`
                  }
                >
                  {item.head}
                </NavLink>
              ))}
            </div>
          </div>
          <div className="flex justify-end items-center gap-2">
            {user?.id ? (
              <div className="hidden lg:flex items-center gap-2">
                <NavLink to={"/chats"} onClick={() => setCurrentConversation(null)}>
                  <Button
                    children="Start Chat"
                    variant="secondary"
                    disabled={false}
                  />
                </NavLink>

                <NavLink to={"/user-setting"}>
                  <Button
                    children="Settings"
                    variant="secondary"
                    disabled={false}
                  />
                </NavLink>
                <Button
                  children="Logout"
                  variant="primary"
                  disabled={false}
                  onClick={HandleUserLogOut}
                />
                <NavLink to={"/user-setting"}>
                  <div className="h-[42px] w-[42px] rounded-full flex items-center justify-center bg-blue ml-3 ring-2 ring-blue/15 hover:ring-blue/30 transition">
                    <h2 className="uppercase text-white font-medium text-sm">
                      {user.name.slice(0, 2)}
                    </h2>
                  </div>
                </NavLink>
              </div>
            ) : (
              <div className="hidden lg:flex items-center gap-2">
                <NavLink to={"/login"}>
                  <Button children="Login" variant="secondary" />
                </NavLink>
                <NavLink to={"/signup"}>
                  <Button children="Sign Up" />
                </NavLink>
              </div>
            )}
            <div className="flex items-center justify-center lg:hidden">
              <MobileHeader activeSection={undefined} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
